const styles = theme => ({
  root: {
    position: 'relative',
    display: 'block',
    margin: [0, 'auto', 10],
    width: '100%'
  },
  svg: {
    display: 'block',
    position: 'absolute',
    left: 0,
    top: 0
  },
  path: {
    opacity: ({ energy }) => energy.animate ? 0 : 1
  },
  content: {
    position: 'relative',
    zIndex: 10,
    display: 'flex',
	alignItems: 'center',
    flexDirection: 'column',
    margin: [0, 'auto'],
    justifyContent: 'space-evenly',
    padding: [20, 20, 10],
    width: '100%',
    maxWidth: 1500
  },
  brand: {
	margin: 0,
	width: '100%',
	maxWidth: 300
  },
 
  menu: {
    width: '100%'
  },

  '@media screen and (min-width: 768px)': {
    root: {
      marginBottom: 20
    },
    content: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      padding: [10, 0, 0]
    },
    brand: {

	  
    },
    menu: {
      margin: 0,
      maxWidth: 375
    }
  },

  '@media screen and (min-width: 1025px)': {
    menu: {
      margin: 0,
      width: 550,
      maxWidth: 'none'
    }
  }
});

export { styles };
